<template>
  <div class="channel-panel web">
    <div class="bg-con home-com-wrap  center">
      <div class="top-panel">
        <div class="left">
          <div class="title">{{$t('home_v2_49')}}</div>
          <div class="sub-title">{{$t('home_v2_50')}}</div>
        </div>
        <div class="right">
          <img src="./imgs/channel.png">
        </div>
      </div>
      <div class="channel-list">
        <div class="row">
          <a :href="$t('link_telegram')" target="_blank">
            <div class="item">
              <img src="./imgs/telegram.svg"/>
              <div class="name">Telegram</div>
            </div>
          </a>
          <a :href="$t('link_discord')" target="_blank">
          <div class="item">
            <img src="./imgs/discord.svg"/>
            <div class="name">Discord</div>
          </div>
          </a>
          <a :href="$t('link_twitter')" target="_blank">
          <div class="item">
            <img src="./imgs/twitter.svg"/>
            <div class="name">Twitter</div>
          </div>
          </a>
        </div>
        <div class="row">
          <a :href="$t('link_facebook')" target="_blank">
          <div class="item">
            <img src="./imgs/facebook.svg"/>
            <div class="name">Facebook</div>
          </div>
          </a>
          <a :href="$t('link_instagram')" target="_blank">
          <div class="item">
            <img src="./imgs/instagram.svg"/>
            <div class="name">Instagram</div>
          </div>
          </a>
          <a :href="$t('link_linkedin')" target="_blank">
          <div class="item">
            <img src="./imgs/linkedin.svg"/>
            <div class="name">Linkedin</div>
          </div>
          </a>
        </div>
        <div class="more" @click="showDialog=true">
          {{$t('home_v2_51')}} ->
        </div>
      </div>
    </div>

    <div class="channel-dialog" v-if="showDialog">
      <transition name="dialog-fade">
      <div class="mask" @click.self="showContent=false" v-show="showContent">
        <div class="dialog-content" >
          <div class="head">
            <img class="close" src="./imgs/close.svg" @click="showContent=false"/>
            <div class="title">
              {{$t('home_v2_52')}}
            </div>
            <div class="channel-list-m">
              <a  :href="$t('link_telegram')" target="_blank">
                <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.69862 12.7558C9.3569 13.0923 9.01139 13.425 8.66283 13.7547C8.31352 14.0837 7.96876 14.4171 7.62705 14.7529C7.5087 14.8588 7.37574 14.9475 7.23217 15.0163C7.09624 15.0788 6.94361 15.1104 6.77275 15.1104C6.67372 15.1016 6.57833 15.0691 6.49482 15.0156C6.41449 14.954 6.35491 14.8698 6.32396 14.7739C6.06729 13.9753 5.80759 13.1728 5.54408 12.3666C5.28058 11.5612 5.01404 10.7587 4.7437 9.96007C4.72334 9.89183 4.69067 9.82781 4.64726 9.77113C4.59728 9.72026 4.53428 9.68383 4.46501 9.66574C3.83929 9.48357 3.21964 9.29764 2.60758 9.1087C1.99553 8.91901 1.37588 8.72705 0.749395 8.53059C0.663586 8.50273 0.582333 8.47413 0.504117 8.44628C0.425968 8.41835 0.350699 8.38306 0.279343 8.34089C0.108483 8.24303 0.0158397 8.12033 0.00217096 7.97355C-0.0130165 7.82601 0.0515303 7.69653 0.194293 7.58437C0.308199 7.48651 0.429699 7.4022 0.557274 7.3322C0.685608 7.26219 0.813183 7.20574 0.941517 7.16433C1.72443 6.8557 2.50811 6.5546 3.29102 6.26028L5.64052 5.37729C6.58227 5.01224 7.52567 4.65142 8.47071 4.29483L11.3108 3.22216C12.2577 2.86535 13.2046 2.50403 14.1516 2.13969C15.0985 1.77536 16.0424 1.4178 16.9818 1.06777C17.3516 0.927757 17.6576 0.941307 17.9006 1.10992C18.1421 1.27779 18.2492 1.55857 18.2203 1.95075C18.192 2.20164 18.1491 2.45071 18.092 2.69673C18.035 2.94213 17.9781 3.19054 17.9211 3.44347C17.7209 4.41503 17.5146 5.38535 17.3022 6.35437C17.0887 7.32771 16.8787 8.30178 16.672 9.27657C16.4653 10.2513 16.2552 11.2254 16.0417 12.1988C15.8283 13.1728 15.6149 14.1431 15.4008 15.1104V15.1526C15.302 15.6005 15.1023 15.8775 14.8031 15.9829C14.5039 16.0882 14.1698 16.007 13.7992 15.7412C13.1439 15.2647 12.4931 14.7913 11.8446 14.3215C11.1969 13.8526 10.5461 13.3791 9.89074 12.9033C9.86394 12.8768 9.83526 12.8521 9.80493 12.8296C9.77017 12.804 9.73472 12.7794 9.69862 12.7558ZM6.79401 13.9542C6.80768 13.9542 6.81831 13.9504 6.82591 13.9436L6.83654 13.9331C6.83654 13.9188 6.84033 13.9015 6.84717 13.8804C6.85348 13.8635 6.85707 13.8457 6.8578 13.8277L6.98613 12.5142C7.02835 12.0769 7.0638 11.639 7.09245 11.2006C7.11993 11.0092 7.21011 10.8319 7.34912 10.6963C8.50529 9.66884 9.66208 8.64208 10.8195 7.61599L12.5501 6.08112C13.1264 5.56925 13.7066 5.06189 14.2906 4.55754C14.39 4.45968 14.4971 4.36183 14.611 4.26322C14.7249 4.16536 14.8312 4.0675 14.9315 3.96889C14.9601 3.94031 14.9787 3.90337 14.9846 3.8635C14.9922 3.82135 15.0021 3.77919 15.0165 3.73779C14.9751 3.73817 14.9344 3.72723 14.8988 3.70618C14.8635 3.68526 14.823 3.67432 14.7819 3.67456C14.709 3.68918 14.6375 3.71034 14.5685 3.73779C14.4944 3.76722 14.4228 3.80246 14.3543 3.84318C14.1975 3.92726 14.0444 4.01818 13.8957 4.11568C13.7461 4.21353 13.5995 4.30537 13.4575 4.38893C12.794 4.80588 12.1283 5.2194 11.4604 5.62947C10.7982 6.03595 10.136 6.44545 9.47384 6.85947C8.81243 7.27273 8.15026 7.68223 7.48808 8.08872C6.82591 8.49521 6.16677 8.90922 5.51219 9.32926C5.42714 9.37141 5.37322 9.42034 5.35272 9.4768C5.3307 9.5325 5.34133 9.60251 5.38385 9.68682C5.46966 9.93899 5.55471 10.1987 5.64052 10.4644C5.72557 10.7309 5.81138 10.9898 5.89643 11.242C6.05362 11.705 6.20626 12.1604 6.35585 12.609C6.50545 13.0569 6.65201 13.5055 6.79401 13.9542Z" fill="#14C393"/>
                </svg>
              </a>
              <a  :href="$t('link_discord')" target="_blank">
              <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.16647 1.1781C5.69402 1.1781 3.26227 2.69673 3.26227 2.69673C4.60017 1.48237 6.92385 0.776937 6.92385 0.776937L6.70769 0.556885C4.51911 0.598541 2.53274 2.14434 2.53274 2.14434C0.304065 6.89402 0.452236 11.0089 0.452236 11.0089C2.26254 13.4114 4.9645 13.2321 4.9645 13.2321L5.88316 12.044C4.26199 11.6854 3.23525 10.222 3.23525 10.222C3.23525 10.222 5.667 11.9199 9.16647 11.9199C12.6659 11.9199 15.0977 10.222 15.0977 10.222C15.0977 10.222 14.0709 11.6989 12.4498 12.044L13.3684 13.2321C13.3684 13.2321 16.0564 13.4114 17.8807 11.0089C17.8807 11.0089 18.0289 6.90851 15.7863 2.14434C15.7863 2.14434 13.8008 0.598541 11.6113 0.556885L11.396 0.777842C11.396 0.777842 13.7328 1.48237 15.0567 2.69764C15.0837 2.69764 12.6389 1.1781 9.16647 1.1781ZM6.49154 6.1904C7.32914 6.1904 8.01858 6.94926 8.00463 7.87475C8.00463 8.78574 7.32914 9.55909 6.49154 9.55909C5.667 9.55909 4.99239 8.78574 4.99239 7.87475C4.99239 6.94926 5.63999 6.1904 6.49154 6.1904ZM11.8954 6.1904C12.733 6.1904 13.4085 6.94926 13.4085 7.87475C13.4085 8.78574 12.733 9.55909 11.8954 9.55909C11.0709 9.55909 10.3963 8.78574 10.3963 7.87475C10.3963 6.94926 11.0448 6.1904 11.8954 6.1904Z" fill="#14C393"/>
              </svg>
              </a>
              <a  :href="$t('link_twitter')" target="_blank">
              <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.3323 2.85409C17.7461 3.74552 17.1295 4.43886 16.4817 4.93411V5.42935C16.4817 8.33503 15.5181 10.9602 13.5908 13.3041C11.6635 15.6472 9.08091 16.8199 5.84295 16.8199C3.74633 16.8199 1.83423 16.2256 0.107422 15.037C0.292708 15.0703 0.585826 15.087 0.986014 15.087C2.71282 15.087 4.2703 14.5085 5.65843 13.3532C4.86964 13.3251 4.10921 13.0394 3.48435 12.5363C2.85187 12.0468 2.38255 11.3625 2.14254 10.5799C2.45084 10.6456 2.68169 10.6789 2.8366 10.6789C3.17604 10.6789 3.51472 10.629 3.85416 10.5299C2.99075 10.3651 2.27391 9.91188 1.70362 9.16862C1.14097 8.44916 0.838101 7.54649 0.847809 6.61793V6.51888C1.46442 6.88179 2.01952 7.06404 2.51311 7.06404C1.43328 6.27166 0.894131 5.14884 0.894131 3.6964C0.894131 2.9365 1.04828 2.27644 1.35659 1.71543C3.36133 4.32317 5.9356 5.70985 9.08091 5.87546C9.0194 5.47927 8.98827 5.18212 8.98827 4.98403C8.98827 3.86121 9.35125 2.91193 10.0757 2.13619C10.7994 1.35965 11.6871 0.972168 12.735 0.972168C13.8452 0.972168 14.7549 1.38421 15.4642 2.21067C16.2927 2.02653 17.0887 1.70895 17.8236 1.26931C17.5456 2.22652 17.0065 2.95314 16.2046 3.44838C16.9348 3.34351 17.6496 3.14387 18.3323 2.85409Z" fill="#14C393"/>
              </svg>
              </a>
              <a  :href="$t('link_facebook')" target="_blank">
              <svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.9338 18.6124H6.49955V9.49991H9.73059L10.0653 6.36704H6.49955V4.80244C6.49955 4.32768 6.57371 3.99507 6.72205 3.80553C6.87134 3.61599 7.22981 3.52031 7.79938 3.52031H10.0653V0.387451H6.79622C5.31097 0.387451 4.29639 0.725523 3.75155 1.40167C3.2067 2.07872 2.93475 3.11663 2.93475 4.5163V6.36796H0.556641V9.49991H2.9338V18.6124Z" fill="#14C393"/>
              </svg>
              </a>
              <a  :href="$t('link_linkedin')" target="_blank">
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.291016 16.786H3.93105V5.62463H0.291016V16.786ZM15.8262 6.64549C15.0458 5.78372 14.0491 5.3524 12.836 5.3524C12.4242 5.3524 12.0023 5.4094 11.5689 5.52255C11.2253 5.61166 10.9041 5.77401 10.6262 5.99895C10.3017 6.29415 10.0954 6.49832 10.0089 6.61147C9.90069 6.72461 9.75925 6.91772 9.5862 7.18995V5.62463H6.01106V9.5039C6.01106 12.3853 6.00025 14.8234 5.97778 16.8201H9.5862V10.5588C9.5862 10.1504 9.62946 9.84419 9.71599 9.64002C9.82415 9.27676 10.0521 8.95944 10.3982 8.68721C10.7235 8.41499 11.1029 8.27887 11.5364 8.27887C12.1646 8.27887 12.6305 8.50601 12.9342 8.95944C13.2154 9.39076 13.356 10.0143 13.356 10.831V16.8201H16.9312V10.3886C16.9312 8.68721 16.5626 7.43921 15.8262 6.64549ZM2.07817 3.99126C2.58494 3.99673 3.07415 3.80164 3.44349 3.4468C3.76797 3.10651 3.93105 2.65308 3.93105 2.08565C3.93105 1.56416 3.7688 1.10988 3.44349 0.724503C3.05328 0.361247 2.62064 0.180044 2.1439 0.180044C1.63712 0.174568 1.14791 0.369656 0.778572 0.724503C0.454089 1.06479 0.291016 1.51822 0.291016 2.08565C0.291016 2.65308 0.453257 3.10651 0.778572 3.4468C1.16878 3.81005 1.60226 3.99126 2.07817 3.99126Z" fill="#14C393"/>
              </svg>
              </a>
              <a  :href="$t('link_instagram')" target="_blank">
              <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.4067 0.387532H5.12896C4.4428 0.387532 3.79491 0.516928 3.18621 0.77572C2.5992 1.02879 2.06551 1.39088 1.61341 1.84278C1.15719 2.29923 0.793876 2.83986 0.543616 3.43471C0.282297 4.04145 0.150099 4.69592 0.155428 5.35652V13.6433C0.155428 14.3167 0.284824 14.9573 0.543616 15.5651C0.792439 16.1578 1.15601 16.6954 1.61341 17.147C2.06789 17.5939 2.60154 17.9524 3.18712 18.2041C3.79809 18.4764 4.46005 18.6156 5.12896 18.6123H13.4067C14.0928 18.6123 14.7407 18.4756 15.3494 18.205C15.9351 17.953 16.4687 17.5942 16.9231 17.147C17.3802 16.6953 17.7434 16.1577 17.992 15.5651C18.2508 14.9573 18.3802 14.3167 18.3802 13.6433V5.35652C18.3802 4.67035 18.2508 4.02975 17.992 3.43471C17.7417 2.83986 17.3784 2.29923 16.9222 1.84278C16.4701 1.39088 15.9364 1.02879 15.3494 0.77572C14.7349 0.515778 14.0739 0.383698 13.4067 0.387532ZM16.729 13.6433C16.729 14.5491 16.4046 15.3255 15.7576 15.9724C15.1098 16.6194 14.3261 16.9429 13.4067 16.9429H5.12896C4.20953 16.9429 3.42586 16.6194 2.77797 15.9724C2.13099 15.3255 1.80659 14.5491 1.80659 13.6433V5.35652C1.80659 4.45075 2.13099 3.67073 2.77797 3.01737C3.08141 2.70113 3.4468 2.45085 3.8513 2.28215C4.2558 2.11344 4.69075 2.02995 5.12896 2.03687H13.4067C14.3261 2.03687 15.1098 2.36401 15.7576 3.01737C16.4046 3.67073 16.729 4.45075 16.729 5.35652V13.6433ZM9.92845 5.35652C9.51743 5.27936 9.09564 5.27936 8.68462 5.35652C8.13832 5.43016 7.61465 5.62202 7.15009 5.91875C6.69632 6.20445 6.30059 6.57328 5.98371 7.00586C5.67389 7.43323 5.44608 7.91163 5.30392 8.44197C5.16177 8.9706 5.12805 9.52252 5.20478 10.0645C5.28152 10.6065 5.46712 11.1274 5.75043 11.5958C6.03565 12.0687 6.40561 12.4724 6.85849 12.8086C7.23392 13.0547 7.6294 13.2551 8.0431 13.41C8.45863 13.5659 8.89238 13.6433 9.34617 13.6433C9.43639 13.6433 9.53662 13.6406 9.64688 13.6342C9.74689 13.6308 9.84414 13.6006 9.92845 13.5467C10.4685 13.4704 10.9874 13.2854 11.4539 13.0027C11.9272 12.7173 12.3396 12.3414 12.6676 11.8965C12.9946 11.4634 13.2289 10.9677 13.3559 10.4402C13.4829 9.91261 13.4999 9.36456 13.4057 8.83016C13.3018 7.95037 12.901 7.13231 12.2694 6.51106C11.6395 5.87622 10.8156 5.46989 9.92845 5.35652ZM11.3463 10.9069C11.1395 11.1529 10.8935 11.3698 10.6082 11.5575C10.3288 11.7428 10.0093 11.859 9.67604 11.8965C9.0154 11.9748 8.40304 11.8163 7.8399 11.4217C7.27584 11.0272 6.94962 10.4923 6.85849 9.81977C6.74186 9.16003 6.89494 8.54859 7.31502 7.98635C7.73602 7.42321 8.27729 7.09607 8.93703 7.00586H9.59859C10.1426 7.09698 10.6028 7.32935 10.9782 7.70478C11.3545 8.08021 11.5869 8.53947 11.678 9.08257C11.7555 9.41973 11.7591 9.74596 11.6871 10.0631C11.6232 10.3618 11.5082 10.6473 11.3473 10.9069H11.3463ZM13.2508 4.366C13.1675 4.43406 13.1011 4.52045 13.0567 4.61841C13.0152 4.72331 12.9954 4.83552 12.9984 4.94828C12.9984 5.06492 13.0176 5.1688 13.0567 5.25902C13.095 5.35014 13.1606 5.44035 13.2508 5.53056C13.3283 5.60893 13.4221 5.66725 13.5333 5.70552C13.6427 5.74471 13.7429 5.76384 13.834 5.76384C13.9402 5.76559 14.0456 5.74575 14.1438 5.70552C14.235 5.66634 14.3261 5.60893 14.4172 5.53056C14.4947 5.43944 14.553 5.3392 14.5913 5.22986C14.6685 5.03336 14.6685 4.81491 14.5913 4.61841C14.5497 4.52383 14.4903 4.43814 14.4163 4.366C14.3414 4.28641 14.2511 4.22296 14.1508 4.17956C14.0505 4.13615 13.9424 4.1137 13.8331 4.11359C13.724 4.11383 13.6161 4.13634 13.5159 4.17974C13.4158 4.22314 13.3256 4.28652 13.2508 4.366Z" fill="#14C393"/>
              </svg>
              </a>
              <a  :href="$t('link_youtube')" target="_blank">
              <svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.0949 11.2718L14.8728 8.28475L9.0949 5.26199V11.2711V11.2718ZM11.3031 0.972168C12.6402 0.972168 13.9315 0.990377 15.1769 1.02528C16.0909 1.04692 17.0043 1.08487 17.9169 1.13909L18.788 1.18765C18.7956 1.18765 18.8644 1.19296 18.9912 1.2051C19.1188 1.21724 19.2097 1.22938 19.2663 1.24076C19.3213 1.2529 19.4153 1.27111 19.5459 1.29463C19.6773 1.3189 19.7904 1.35077 19.8867 1.39022C19.9822 1.43044 20.093 1.48127 20.2206 1.54576C20.3482 1.6095 20.4712 1.68689 20.5912 1.77869C20.7917 1.93357 20.9703 2.1145 21.1222 2.31663C21.1978 2.41526 21.3132 2.64895 21.4683 3.01465C21.6234 3.38188 21.7289 3.784 21.7847 4.22254C21.8481 4.73165 21.8977 5.27565 21.9336 5.8538C21.9696 6.43043 21.9917 6.88263 21.9994 7.20888V9.31206C22.0072 10.4706 21.9354 11.6283 21.7847 12.7772C21.7369 13.1845 21.6367 13.584 21.4867 13.9661C21.343 14.3204 21.2154 14.5655 21.1046 14.7005L20.9365 14.9039C20.8305 15.0189 20.7149 15.125 20.5912 15.221C20.4712 15.3121 20.3482 15.3879 20.2206 15.4479C20.1104 15.5001 19.9991 15.5499 19.8867 15.5973C19.7769 15.6412 19.6626 15.6733 19.5459 15.6929C19.4503 15.7099 19.3548 15.7276 19.2594 15.746C19.1686 15.7624 19.077 15.7745 18.9851 15.7825C18.9195 15.7892 18.8537 15.795 18.788 15.7999C16.7907 15.9517 14.2952 16.0275 11.3031 16.0275C9.87225 16.0154 8.44158 15.9894 7.01127 15.9494C6.21296 15.9298 5.41494 15.9 4.61742 15.8599L4.0329 15.8121L3.60273 15.7643C3.38382 15.7372 3.1667 15.6975 2.9525 15.6451C2.7423 15.5798 2.53848 15.4958 2.34353 15.394C2.00239 15.231 1.70711 14.9868 1.48395 14.6831C1.4083 14.5837 1.29293 14.35 1.13782 13.9843C0.97748 13.5984 0.871052 13.1925 0.821494 12.7779C0.75494 12.2358 0.705251 11.6918 0.672499 11.1467C0.642339 10.6946 0.620177 10.2421 0.606025 9.7893V7.68688C0.598384 6.5321 0.669443 5.37732 0.82073 4.22254C0.876507 3.784 0.975837 3.38795 1.11872 3.03286C1.26237 2.67854 1.38997 2.43347 1.50076 2.29842L1.66885 2.09508C1.77496 1.98031 1.89048 1.87448 2.01422 1.77869C2.13417 1.68764 2.25719 1.6095 2.38479 1.54576C2.51163 1.48203 2.62318 1.43044 2.71869 1.39022C2.8142 1.35077 2.92805 1.3189 3.05947 1.29463C3.19013 1.27111 3.28411 1.2529 3.33988 1.24152C3.39566 1.22938 3.48659 1.21724 3.61495 1.2051C3.74179 1.19296 3.80903 1.18765 3.81743 1.18765C5.81549 1.04349 8.31096 0.972168 11.3031 0.972168Z" fill="#14C393"/>
              </svg>
              </a>
            </div>
          </div>
          <div class="language-list">
            <div class="item" @click="go('https://t.me/BitForex_official_news')">
              <div class="name">{{$t('home_v2_26')}}</div>
              <div class="link-text">https://t.me/BitForex_official_news</div>
            </div>
<!--            <div class="item" @click="go('https://t.me/BitForexVietnamese')">-->
<!--              <div class="name">Tiếng Việt-->
<!--                </div>-->
<!--              <div class="link-text">https://t.me/BitForexVietnamese</div>-->
<!--            </div>-->
<!--            <div class="item" @click="go('https://t.me/BitForexBangladesh')">-->
<!--              <div class="name">Bangladesh-->
<!--                </div>-->
<!--              <div class="link-text">https://t.me/BitForexBangladesh</div>-->
<!--            </div>-->
            <div class="item" @click="go('https://t.me/BitForexEnglish')">
              <div class="name">English
                </div>
              <div class="link-text">https://t.me/BitForexEnglish</div>
            </div>
<!--            <div class="item" @click="go('https://t.me/BitForexIndonesia')">-->
<!--              <div class="name">Indonesian-->
<!--                </div>-->
<!--              <div class="link-text">https://t.me/BitForexIndonesia</div>-->
<!--            </div>-->
<!--            <div class="item" @click="go('https://t.me/BitForex_Africa')">-->
<!--              <div class="name">Africa-->
<!--                </div>-->
<!--              <div class="link-text">https://t.me/BitForex_Africa</div>-->
<!--            </div>-->
            <div class="item" @click="go('https://t.me/BitForexKorean')">
              <div class="name">한국어
                </div>
              <div class="link-text">https://t.me/BitForexKorean</div>
            </div>
            <div class="item" @click="go('https://t.me/BitForexRussian')">
              <div class="name">русский
              </div>
              <div class="link-text">https://t.me/BitForexRussian</div>
            </div>
            <div class="item" @click="go('https://t.me/BitforexPT')">
              <div class="name">Comunicados
              </div>
              <div class="link-text">https://t.me/BitforexPT</div>
            </div>
<!--            <div class="item" @click="go('https://t.me/BitForexTurkish')">-->
<!--              <div class="name">Türkçe-->
<!--                </div>-->
<!--              <div class="link-text">https://t.me/BitForexTurkish</div>-->
<!--            </div>-->
<!--            <div class="item" @click="go('https://t.me/BitForex_Arabic')">-->
<!--              <div class="name">عرب-->
<!--               </div>-->
<!--              <div class="link-text">https://t.me/BitForex_Arabic</div>-->
<!--            </div>-->
          </div>
          <div style="border-top:1px solid #c8c8c8;margin:-20px 28px 0 28px"></div>
          <div class="language-list">
            <div class="item" @click="go('https://twitter.com/bitforexcom')">
              <div class="name">@bitforexcom
                </div>
              <div class="link-text">https://twitter.com/bitforexcom</div>
            </div>
            <div class="item" @click="go('https://twitter.com/bitforexpt')">
              <div class="name">@bitforexPT
                </div>
              <div class="link-text">https://twitter.com/bitforexpt</div>
            </div>
          </div>
          <div class="btn-group">
            <div class="btn-right" @click="showContent=false">
              {{$t('home_v2_53')}}
            </div>
          </div>
        </div>

      </div>
      </transition>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'Channel',
    data () {
      return {
        showDialog: false,
        showContent: false
      };
    },
    watch: {
      showDialog (val) {
        if (!val) return;
        setTimeout(() => {
          this.showContent = val;
        }, 100);
      },
      showContent (val) {
        if (val) return;
        setTimeout(() => {
          this.showDialog = val;
        }, 100);
      }
    },
    methods: {
      go (url) {
        window.open(url);
      }
    }
  };
</script>

<style scoped lang="scss">

  .channel-panel {

    .top-panel {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left {
        .title {
          font-style: normal;
          font-weight: bold;
          font-size: 36px;
          line-height: 42px;
          color: #000000;
        }

        .sub-title {
          font-style: normal;
          font-weight: normal;
          font-size: 18px;
          line-height: 21px;
          color: #8E8E8E;
          margin-top: 28px;
        }
      }

      .right {
        img {

        }
      }
    }
    .channel-list{
      margin-top: 35px;
      .row{
        display: flex;
        justify-content: space-between;
        margin-bottom: 25px;
        .item{
          background: #FFFFFF;
          border: 1px solid #DBE4EF;
          box-sizing: border-box;
          border-radius: 2px;
          width: 378px;
          padding: 16px 0px 16px 110px;
          display: flex;
          align-items: center;
          cursor: pointer;
          .name{
            margin-left: 24px;
            font-style: normal;
            font-weight: normal;
            font-size: 18px;
            line-height: 21px;
            color: #8E8E8E;
          }
          &:hover{
            border: 1px solid #14C393;
            .name{
              font-weight: bold;

              color: #14C393;
            }
          }
        }
      }
      .more{
        margin-top: 15px;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        color: #039A71;
        opacity: 0.6;
        cursor: pointer;
      }
    }
    .dialog-fade-enter-active {
      animation: dialog-fade-in .3s;
    }

    .dialog-fade-leave-active {
      animation: dialog-fade-out .3s;
    }
    @keyframes dialog-fade-in {
      0% {
        transform: translateY(-20px);
        opacity: 0;
      }

      100% {
        transform: translateY(0);
        opacity: 1;
      }
    }

    @keyframes dialog-fade-out {
      0% {
        transform: translateY(0);
        opacity: 1;
      }

      100% {
        transform: translateY(-20px);
        opacity: 0;
      }
    }
    .channel-dialog{
      .mask{
        position: fixed;
        width: 100vw;
        height: 100vh;
        left: 0;
        top: 0;
        z-index: 10001;
        background: rgba(0,0,0,0.8);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .dialog-content{
          width: 601px;
          background: #FFFFFF;
          box-shadow: 0px 24px 52px rgba(0, 0, 0, 0.25);
          border-radius: 6px;
          .head{
            position: relative;
            background-image: url("./imgs/headbg.svg");
            padding-top: 50px;
            padding-bottom: 44px;
            text-align: center;
            height: 150px;
            .title{
              font-style: normal;
              font-weight: bold;
              font-size: 24px;
              line-height: 28px;
              color: #FFFFFF;
              margin-bottom: 17px;
            }
            .channel-list-m{
              svg{
                margin:0 9px;
              }
            }
            .close{
              position: absolute;
              top: 25px;
              right: 32px;
              cursor: pointer;
            }
          }
          .language-list{
            padding: 28px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            .item{
              background: #FFFFFF;
              border: 1px solid #C8C8C8;
              box-sizing: border-box;
              border-radius: 6px;
              width: 263px;
              height: 69px;
              padding: 17px 27px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              margin-bottom: 20px;
              cursor: pointer;
              .name{
                font-style: normal;
                font-weight: bold;
                font-size: 12px;
                line-height: 14px;
                color: #111111;
              }
              .link-text{
                font-style: normal;
                font-weight: bold;
                font-size: 12px;
                line-height: 14px;
                color: #8E8E8E;
              }
            }
          }
          .btn-group{
            display: flex;
            justify-content: flex-end;
            width: 100%;
            padding: 5px 36px 40px 36px;
            .btn-right{
              background: #14C393;
              border: 1px solid #14C393;
              box-sizing: border-box;
              border-radius: 6px;
              padding: 10px 38px;

              font-style: normal;
              font-weight: bold;
              font-size: 14px;
              line-height: 16px;
              color: #FFFFFF;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 1199px) {
  .channel-panel{
    display: none;
  }
}

</style>
